// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 151 ? "wheel-preview" : chunkId) + "." + {"134":"3438fe37","151":"fb51d2d9","179":"703d9a4a","203":"3438fe37","426":"3438fe37","725":"011185b0"}[chunkId] + ".chunk.css";
};